<template>
  <v-card flat>
    <v-card-title class="text-center justify-center">
      <v-btn absolute icon right @click="$emit('back')">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>

      ابعاد تصویر
    </v-card-title>

    <v-list>
      <v-list-item-group v-model="selectedValue">
        <v-list-item v-for="(item, i) in ratio" :key="i" :value="item.value" dense @click="setRatio(item)">
          <v-list-item-avatar class="pa-4 border" size="54">
            <v-card :style="{aspectRatio: item.ratio}" outlined width="100%"/>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ item.value }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: "DesignCanvasRatio",

  props: {
    value: String
  },

  data: () => ({
    selectedValue: '16/9',
    ratio: [
      {value: '1:1', formula: 1 / 1, name: 'مربع', ratio: 1 / 1},
      {value: '3:4', formula: 4 / 3, name: 'پرتره', ratio: 3 / 4},
      {value: '4:3', formula: 3 / 4, name: 'پست', ratio: 4 / 3},
      {value: '9:16', formula: 16 / 9, name: 'استوری', ratio: 9 / 16},
      {value: '16:9', formula: 9 / 16, name: 'عریض', ratio: 16 / 9},
    ]
  }),

  computed: {
    computedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    setRatio(item) {
      this.selectedValue = item.value
      const pt = (item.formula * 100).toFixed(2)
      this.computedValue = `${pt}%`
      this.$emit('change', 'ratio')
    }
  }
}
</script>

<style scoped>

</style>